import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Registration} from '../../../shared/interface/registration';
import {FormBuilder, FormControl} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {Meeting} from '../../../shared/interface/meeting';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MeetingService} from '../../../shared/services/meeting.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {startWith, takeUntil, tap} from 'rxjs/operators';
import {RegistrationService} from '../../../shared/services/registration.service';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {
  EXAM_TYPE_100P,
  EXAM_TYPE_40P,
  IDD_TRAINING_STATUS_DURING,
  IDD_TRAINING_STATUS_TO_BE_REAIZED,
  MEETING_EXAM_TYPE_100P,
  MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_EXAM,
  MEETING_TYPE_IDD_TRAINING,
  MEETING_TYPE_NEW_AGENT_TRAINING,
  OFWCA_STATUS_ACTIVE,
  OFWCA_STATUS_NEW,
  REGISTRATION_STATUS_REGISTRATION_REQUEST,
  WHAT_IS_NEEDED_EXAM_AND_REGISTRATION
} from '../../../shared/services/dict.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {OfwcaMeeting} from '../../../shared/interface/ofwca-meeting';
import {IddTraining} from '../../../shared/interface/idd-training';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {ChartType} from '../../idd-trainings/idd-training-chart/idd-training-chart.component';
import {AuthService} from '../../../shared/services/auth.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {Ofwca} from "../../../shared/interface/ofwca";
import {OfwcaService} from "../../../shared/services/ofwca.service";

export interface OfwcaToRegisterForm {
  registration?: Registration;
  iddTraining?: IddTraining;
  ofwca?: Ofwca;
  checkbox: FormControl;
}

@Component({
  selector: 'app-ofwca-to-register-list',
  templateUrl: './ofwca-to-register-list.component.html',
  styleUrls: ['./ofwca-to-register-list.component.scss']
})
export class OfwcaToRegisterListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() meeting: Observable<Meeting>;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;
  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly chartType = ChartType.Horizontal;

  meetingObject: Meeting;
  ofwcaDataSource: MatTableDataSource<OfwcaToRegisterForm> = new MatTableDataSource<OfwcaToRegisterForm>([]);
  ofwcaDataSourceActive: MatTableDataSource<OfwcaToRegisterForm> = new MatTableDataSource<OfwcaToRegisterForm>([]);
  totalData = 0;
  displayedColumns: string[] = [];
  forms: OfwcaToRegisterForm[] = [];
  formsActive: OfwcaToRegisterForm[] = [];
  ofwcas: Ofwca[] = [];
  processingRequest = false;
  ofwcaControl: FormControl;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private ofwcaService: OfwcaService,
    private meetingService: MeetingService,
    private registrationService: RegistrationService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private iddTrainingService: IddTrainingService,
    private auth: AuthService,
  ) {
    this.ofwcaControl = fb.control('');
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.meeting
      .pipe(takeUntil(this.destroyed$))
      .subscribe((meeting: Meeting) => {
        this.meetingObject = meeting;
        this.loadRegistrations();
        if (meeting.type.key === MEETING_TYPE_EXAM || meeting.type.key === MEETING_TYPE_ENTRANCE_EXAM) {
          this.displayedColumns = ['ofwca', 'activeKrk',  'facilityAddress',
            'assetsRegional', 'partnerAssetsRegional', 'createdAt', 'checkbox'];
        }

        if (meeting.type.key === MEETING_TYPE_IDD_TRAINING) {
          this.displayedColumns = ['ofwca', 'livingAddress', 'facilityAddress', 'partner',
            'ofwcaAssetsRegional', 'partnerAssetsRegional', 'chart', 'checkbox'];
        }

        if (meeting.type.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
          this.displayedColumns = ['ofwca', 'status', 'livingAddress', 'facilityAddress', 'partner',
            'ofwcaAssetsRegional', 'partnerAssetsRegional', 'checkbox'];
        }
      });

    this.registrationService.getRegistrationShortListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: CountedAndPaginated<Registration>) => {
        this.meetingService.getRegisteredOfwcas(this.meetingObject.uuid, null)
          .subscribe((registeredOfwcas: ListResponse<OfwcaMeeting>) => {
            const ofwcaIds = [];
            registeredOfwcas.items.forEach((ofwcaMeeting: OfwcaMeeting) => {
              ofwcaIds.push(ofwcaMeeting.ofwca.uuid);
            });
            this.forms = [];
            this.formsActive = [];
            response.items.forEach((registration: Registration) => {
              if (ofwcaIds.includes(registration.ofwca.uuid)) {
                return;
              }
              ofwcaIds.push(registration.ofwca.uuid);

              this.forms.push({
                registration,
                checkbox: this.fb.control(false)
              });
              if (registration.ofwca.status?.key !== 'inactive'){
                this.formsActive.push({
                  registration,
                  checkbox: this.fb.control(false)
                });
              }
            });

            this.ofwcaDataSource.data = this.forms;
            this.ofwcaDataSourceActive.data = this.formsActive;
          });
      });

    this.iddTrainingService.iddTrainingListSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: CountedAndPaginated<IddTraining>) => {
        this.meetingService.getRegisteredOfwcas(this.meetingObject.uuid, null)
          .subscribe((registeredOfwcas: ListResponse<OfwcaMeeting>) => {
            const ofwcaIds = [];
            registeredOfwcas.items.forEach((ofwcaMeeting: OfwcaMeeting) => {
              ofwcaIds.push(ofwcaMeeting.ofwca.uuid);
            });
            this.forms = [];
            this.formsActive = [];
            response.items.forEach((iddTraining: IddTraining) => {
              if (ofwcaIds.includes(iddTraining.ofwca.uuid)) {
                return;
              }
              ofwcaIds.push(iddTraining.ofwca.uuid);

              this.forms.push({
                iddTraining,
                checkbox: this.fb.control(false)
              });
              if (iddTraining.ofwca.status?.key !== 'inactive'){
                this.formsActive.push({
                  iddTraining,
                  checkbox: this.fb.control(false)
                });
              }
            });

            this.ofwcaDataSource.data = this.forms;
            this.ofwcaDataSourceActive.data = this.formsActive;
            this.totalData = response.pagination.total;
          });
      });
    this.ofwcaService.getOfwcaListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: CountedAndPaginated<Ofwca>) => {
        this.meetingService.getRegisteredOfwcas(this.meetingObject.uuid, null)
          .subscribe((registeredOfwcas: ListResponse<OfwcaMeeting>) => {
            const ofwcaIds = [];
            registeredOfwcas.items.forEach((ofwcaMeeting: OfwcaMeeting) => {
              ofwcaIds.push(ofwcaMeeting.ofwca.uuid);
            });
            this.forms = [];
            this.formsActive = [];
            response.items.forEach((ofwca: Ofwca) => {
              if (ofwcaIds.includes(ofwca.uuid)) {
                return;
              }
              ofwcaIds.push(ofwca.uuid);

              this.forms.push({
                ofwca,
                checkbox: this.fb.control(false)
              });
              if (ofwca.status?.key !== 'inactive'){
                this.formsActive.push({
                  ofwca,
                  checkbox: this.fb.control(false)
                });
              }
            });

            this.ofwcaDataSource.data = this.forms;
            this.ofwcaDataSourceActive.data = this.formsActive;
            this.totalData = response.pagination.total;
          });
      });

    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.meetingObject.type.key === MEETING_TYPE_IDD_TRAINING) {
          this.loadIddTrainings();
        } else if (this.meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
          this.loadNewTrainings();
        } else {
          this.loadRegistrations();
        }
      });
  }

  loadRegistrations(): void {
    const filters: any = {};

    if (this.meetingObject.examType?.key === MEETING_EXAM_TYPE_100P) {
      filters.missingExamKey = EXAM_TYPE_100P;
      filters.hasDiploma = 1;
      filters.activeContract = 1;
      filters.statusKeys = [REGISTRATION_STATUS_REGISTRATION_REQUEST];
      filters.ofwcaSignedFor100pExam = 0;
    } else {
      filters.missingExamKey = EXAM_TYPE_40P;
      filters.hasDiploma = 1;
      filters.statements = 1;
      filters.passedExam100p = 1;
      filters.activeContract = 1;
      filters.statusKeys = [REGISTRATION_STATUS_REGISTRATION_REQUEST];
      filters.insuranceCompany = this.meetingObject?.insuranceCompany?.id;
      filters.canSignUpForAnExam = 1;
    }

    if (this.ofwcaControl.value) {
      filters.ofwca = this.ofwcaControl.value;
    }

    this.forms = [];
    this.formsActive = [];
    this.ofwcaDataSource.data = this.forms;
    this.ofwcaDataSourceActive.data = this.formsActive;
    this.registrationService.loadShortList(0, 99999, filters, {sortBy: 'createdAt', sortOrder: 'asc'});
  }

  ngAfterViewInit(): void {
    if (this.meetingObject.type.key === MEETING_TYPE_IDD_TRAINING) {
      this.paginator.page
        .pipe(
          takeUntil(this.destroyed$),
          startWith('')
        ).subscribe(() => this.loadIddTrainings());
    } else if (this.meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
      this.paginator.page
        .pipe(
          takeUntil(this.destroyed$),
          startWith('')
        ).subscribe(() => this.loadNewTrainings());
    } else{
      this.ofwcaDataSource.paginator = this.paginator;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOfwcas(): void {
    const ofwcaIds = [];

    this.forms.forEach((form: OfwcaToRegisterForm) => {
      if (form.checkbox.value) {
        if (form.registration) {
          ofwcaIds.push(form.registration.ofwca.uuid);
        }

        if (form.iddTraining) {
          ofwcaIds.push(form.iddTraining.ofwca.uuid);
        }
        if (form.ofwca) {
          ofwcaIds.push(form.ofwca.uuid);
        }
      }
    });

    if (ofwcaIds.length > 0) {
      this.processingRequest = true;
      this.meetingService.registerToMeeting(this.meetingObject.uuid, ofwcaIds)
        .subscribe(() => {
          this.snack.open('OFWCA zostały zapisane na spotkanie', '', {duration: 2000});
          this.processingRequest = false;
          this.changed.emit();

          if (this.meetingObject.type.key === MEETING_TYPE_IDD_TRAINING) {
            this.loadIddTrainings();
          } else if (this.meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
            this.loadNewTrainings();
          } else {
            this.loadRegistrations();
          }
        }, (error: HttpErrorResponse) => {
          this.snack.open('Przy zapisywaniu wystąpił błąd: ' + error?.error?.error?.text, error.status.toString(), {duration: 2000});
          this.processingRequest = false;
        });
    } else {
      this.snack.open('Zaznacz OFWCA do zapisania', '', {duration: 2000});
    }
  }

  selectAll(): void {
    this.forms.forEach((ofwcaToRegisterForm: OfwcaToRegisterForm) => {
      ofwcaToRegisterForm.checkbox.setValue(true);
    });
  }

  unselectAll(): void {
    this.forms.forEach((ofwcaToRegisterForm: OfwcaToRegisterForm) => {
      ofwcaToRegisterForm.checkbox.setValue(false);
    });
  }

  disableAboveLimit(): void {
    if (!this.meetingObject.limitOfPeople) {
      return;
    }

    let selected = 0;

    this.forms.forEach((form: OfwcaToRegisterForm) => {
      if (form.checkbox.value) {
        selected++;
      }
    });

    if (selected >= this.meetingObject.placesLeft) {
      this.forms.forEach((form: OfwcaToRegisterForm) => {
        if (!form.checkbox.value) {
          form.checkbox.disable();
        }
      });
    } else {
      this.forms.forEach((form: OfwcaToRegisterForm) => {
        form.checkbox.enable();
      });
    }
  }
  registerOfwcasActive(): void {
    const ofwcaIds = [];

    this.formsActive.forEach((formsActive: OfwcaToRegisterForm) => {
      if (formsActive.checkbox.value) {
        if (formsActive.registration) {
          ofwcaIds.push(formsActive.registration.ofwca.uuid);
        }

        if (formsActive.iddTraining) {
          ofwcaIds.push(formsActive.iddTraining.ofwca.uuid);
        }
        if (formsActive.ofwca) {
          ofwcaIds.push(formsActive.ofwca.uuid);
        }
      }
    });

    if (ofwcaIds.length > 0) {
      this.processingRequest = true;
      this.meetingService.registerToMeeting(this.meetingObject.uuid, ofwcaIds)
        .subscribe(() => {
          this.snack.open('OFWCA zostały zapisane na spotkanie', '', {duration: 2000});
          this.processingRequest = false;
          this.changed.emit();

          if (this.meetingObject.type.key === MEETING_TYPE_IDD_TRAINING) {
            this.loadIddTrainings();
          } else if (this.meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
            this.loadNewTrainings();
          } else {
            this.loadRegistrations();
          }
        }, (error: HttpErrorResponse) => {
          this.snack.open('Przy zapisywaniu wystąpił błąd: ' + error?.error?.error?.text, error.status.toString(), {duration: 2000});
          this.processingRequest = false;
        });
    } else {
      this.snack.open('Zaznacz OFWCA do zapisania', '', {duration: 2000});
    }
  }
  selectAllActive(): void {
    this.formsActive.forEach((ofwcaToRegisterForm: OfwcaToRegisterForm) => {
      ofwcaToRegisterForm.checkbox.setValue(true);
    });
  }
  unselectAllActive(): void {
    this.formsActive.forEach((ofwcaToRegisterForm: OfwcaToRegisterForm) => {
      ofwcaToRegisterForm.checkbox.setValue(false);
    });
  }
  disableAboveLimitActive(): void {
    if (!this.meetingObject.limitOfPeople) {
      return;
    }

    let selected = 0;

    this.formsActive.forEach((formsActive: OfwcaToRegisterForm) => {
      if (formsActive.checkbox.value) {
        selected++;
      }
    });

    if (selected >= this.meetingObject.placesLeft) {
      this.formsActive.forEach((formsActive: OfwcaToRegisterForm) => {
        if (!formsActive.checkbox.value) {
          formsActive.checkbox.disable();
        }
      });
    } else {
      this.formsActive.forEach((formsActive: OfwcaToRegisterForm) => {
        formsActive.checkbox.enable();
      });
    }
  }

  private loadIddTrainings(): void {
    const filters: any = {};

    filters.notRegisteredToMeeting = this.meetingObject.uuid;

    if (this.ofwcaControl.value) {
      filters.ofwca = this.ofwcaControl.value;
    }

    this.forms = [];
    this.formsActive = [];
    this.ofwcaDataSource.data = this.forms;
    this.ofwcaDataSourceActive.data = this.formsActive;
    this.iddTrainingService.loadList(this.paginator.pageIndex, this.paginator.pageSize, filters);
  }
  private loadNewTrainings(): void {
    const filters: any = {
      status: [24, 316] ,
    };
    filters.notRegisteredToMeeting = this.meetingObject.uuid;

    if (this.ofwcaControl.value) {
      filters.uuid = this.ofwcaControl.value;
    }

    this.forms = [];
    this.formsActive = [];
    this.ofwcaDataSource.data = this.forms;
    this.ofwcaDataSourceActive.data = this.formsActive;
    this.ofwcaService.loadList(this.paginator.pageIndex, this.paginator.pageSize, filters, null , {
      sortBy: 'fullNameReversed',
      sortOrder: 'asc'
    });
  }

}
